import type { GoldenChallengeSuggestion } from "../../../../services/webServices/challenge/suggestions";
import type { JalaliDateParts } from "../../../../utils/jalaliDate";

export const GOLDEN_WEEK_DAY = 6;

// The chains API uses 0 (Saturday) .. 6 (Friday), same as the wizard.
export const toBackendWeekDay = (weekDay: number): number => weekDay;

export const fromBackendWeekDay = (weekDay: number): number => weekDay;

export interface ChainDayState {
  weekDay: number;
  label: string;
  isGolden: boolean;
  suggestions: GoldenChallengeSuggestion[];
  suggestionsLoading: boolean;
  suggestionOffset: number;
  selectedSuggestionId: string | null;
}

export interface ChainDateRange {
  from: JalaliDateParts;
  to: JalaliDateParts;
}

export interface ChainFormState {
  lesson: string;
  grade: string;
  activeWeekDay: number;
  days: ChainDayState[];
  dateRange: ChainDateRange | null;
}

export const WIZARD_STEP_IDS = ["content", "schedule", "preview"] as const;
export type WizardStepId = typeof WIZARD_STEP_IDS[number];
